// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".accordion{max-width:600px;margin:2rem auto}.accordion-title{display:flex;flex-direction:row;justify-content:space-between;cursor:pointer;background-color:#d6d5d5}.accordion-title:hover{background-color:#777}.accordion-title,.accordion-content{padding:1rem}.accordion-content{background-color:#fff}\n", ""]);
// Exports
module.exports = exports;
